<mat-toolbar>
  <span translate>SYNC_15MIN</span>
</mat-toolbar>

<div class="row mt-3">
  <div class="col-md-6">
    <mat-form-field class="w-100">
      <mat-label translate>SEARCH</mat-label>
      <input type="text" matInput [(ngModel)]="searchText"  (keyup)="applyFilter()">
      @if (searchText) {
        <button mat-icon-button color="primary" matSuffix (click)="$event.stopPropagation();searchText = null;applyFilter();"><mat-icon>close</mat-icon></button>
      }
    </mat-form-field>
  </div>
  <div class="col-md-3">
    <mat-form-field class="w-100">
      <mat-label>Sync Start</mat-label>
      <input  matInput #sdInput [matDatepicker]="sdPicker" (focus)="sdPicker.open()" [max]="dates.end" name="start_date" [(ngModel)]="dates.start" >
      <mat-datepicker-toggle matSuffix [for]="sdPicker"></mat-datepicker-toggle>
      <mat-datepicker #sdPicker (closed)="sdInput.blur()"></mat-datepicker>
    </mat-form-field>
  </div>
  <div class="col-md-3">
    <mat-form-field class="w-100">
      <mat-label>Sync End</mat-label>
      <input  matInput #edInput [matDatepicker]="edPicker" (focus)="edPicker.open()" [min]="dates.start" name="end_date" [(ngModel)]="dates.end">
      <mat-datepicker-toggle matSuffix [for]="edPicker"></mat-datepicker-toggle>
      <mat-datepicker #edPicker (closed)="edInput.blur()"></mat-datepicker>
    </mat-form-field>
  </div>
</div>

<table mat-table [dataSource]="dataSource" matSort class="w-100">
  <ng-container matColumnDef="nodeid">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      Node ID
    </th>
    <td mat-cell *matCellDef="let element"> {{element.nodeID}} </td>
  </ng-container>
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      <span translate>NAME</span>
    </th>
    <td mat-cell *matCellDef="let element"> {{element.name}} </td>
  </ng-container>
  <ng-container matColumnDef="target">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      <span translate>TARGET</span>
    </th>
    <td mat-cell *matCellDef="let element"> {{element.target || '-'}} </td>
  </ng-container>
  <ng-container matColumnDef="site">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      <span translate>SITE</span>
    </th>
    <td mat-cell *matCellDef="let element"> {{element.site ? element.site.fullAddress() : ''}} </td>
  </ng-container>
  <ng-container matColumnDef="sync">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      <span translate>Sync Attributes</span></th>
      <td mat-cell *matCellDef="let element"> {{element.getSync15MinAttr(true)}}</td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef ></th>
      <td mat-cell *matCellDef="let element">
        <button type="button" mat-icon-button color="primary" (click)="onSyncClick(element)"><mat-icon>sync</mat-icon></button>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  @if (devices.length === 0) {
    <div class="d-block text-center bg-white p-3" translate>NO_DATA</div>
  }
  <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
